import moment from 'moment';
import { Utils } from '@mvrb-frontend/shared-ui';
export default class ReviewItemModel {
  id: string;
  name: string;
  title: string;
  boardName: string;
  organizationName: string;
  totalReviewTime?: string;
  commentPeriod?: string;
  responsePeriod?: string;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.title = data.title;
    this.boardName = data.board?.name;
    this.organizationName = data.organization?.name;
    this.commentPeriod =
      data.publishedAt && data.commentDueAt
        ? Utils.calculatePeriodInDays(data.publishedAt, data.commentDueAt) + ' days'
        : undefined;
    this.responsePeriod =
      data.commentDueAt && data.responseDueAt
        ? Utils.calculatePeriodInDays(data.commentDueAt, data.responseDueAt) + ' days'
        : undefined;
    this.totalReviewTime =
      data.publishedAt && data.responseDueAt
        ? Utils.calculatePeriodInDays(data.publishedAt, data.responseDueAt) + ' days'
        : undefined;
  }
}
